import { UserInfo } from 'models';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface IUserDataProps {
  isPcOrderOBO?: boolean;
}

export const useUserData = (props: IUserDataProps = {}): UserInfo => {
  const { isPcOrderOBO = false } = props;
  const { currentUser } = useSelector((state: RootState) => state.baseReducer);
  const { isOnBehalf, userOnBehalf, pcOrderOBO } = useSelector(
    (state: RootState) => state.onBehalfReducer,
  );
  const { userOnBehalf: userPcOrderOBO } = pcOrderOBO;

  if (isOnBehalf) return userOnBehalf;

  if (isPcOrderOBO) return userPcOrderOBO;

  return currentUser;
};